export default __webpack_public_path__ + "static/media/leaf.a4778ef8.png";